<template>
  <div id="info">
    <van-nav-bar
      title="个人信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      style="margin-bottom: 20px;"
    />
    <van-form>
      <van-field
        v-model="postForm.name"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-collapse v-model="activeNames">
        <van-collapse-item title="身份证" name="1">
          <van-field
            v-model="postForm.id_card"
            name="身份证号码"
            label="身份证号码"
            placeholder="身份证号码"
            :rules="[{ required: true, message: '请填写身份证号码' }]"
          />
          <uploader :imgUrl="postForm.id_card_img_front" @changeImage="changeIdCardFront" :title="postForm.id_card_img_front_title"></uploader>
          <uploader :imgUrl="postForm.id_card_img_back" @changeImage="changeIdCardBack" :title="postForm.id_card_img_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="健康报告" name="2">
          <uploader :imgUrl="postForm.health_code_img" @changeImage="changeHealthCodeImg" :title="postForm.health_code_img_title"></uploader>
          <uploader :imgUrl="postForm.trajectory_img" @changeImage="changeTrajectoryImg"  :title="postForm.trajectory_img_title"></uploader>
          <uploader :imgUrl="postForm.nucleic_img" @changeImage="changeNucleicImg" :title="postForm.nucleic_img_title"></uploader>
          <uploader :imgUrl="postForm.pass_check_img" @changeImage="changePassCheckImg" :title="postForm.pass_check_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="电工证" name="3">
          <uploader :imgUrl="postForm.electrician_front_img" @changeImage="changeEleFrontImg" :title="postForm.other_front_title"></uploader>
          <uploader :imgUrl="postForm.electrician_back_img" @changeImage="changeEleBackImg" :title="postForm.other_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="制冷证" name="4">
          <uploader :imgUrl="postForm.refrigeration_front_img" @changeImage="changeRefrigerationFrontImg" :title="postForm.other_front_title"></uploader>
          <uploader :imgUrl="postForm.refrigeration_back_img" @changeImage="changeRefrigerationBackImg" :title="postForm.other_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="高空证" name="5">
          <uploader :imgUrl="postForm.high_front_img" @changeImage="changeHighFrontImg" :title="postForm.other_front_title"></uploader>
          <uploader :imgUrl="postForm.high_back_img" @changeImage="changeHighBackImg" :title="postForm.other_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="焊工证" name="6">
          <uploader :imgUrl="postForm.weld_front_img" @changeImage="changeWeldFrontImg" :title="postForm.other_front_title"></uploader>
          <uploader :imgUrl="postForm.weld_back_img" @changeImage="changeWeldBackImg" :title="postForm.other_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="其他证件" name="7">
          <uploader :imgUrl="postForm.other_front_img" @changeImage="changeOtherFrontImg" :title="postForm.other_front_title"></uploader>
          <uploader :imgUrl="postForm.other_back_img" @changeImage="changeOtherBackImg" :title="postForm.other_back_title"></uploader>
        </van-collapse-item>
        <van-collapse-item title="银行卡信息" name="8">
          <van-field
            v-model="postForm.bank_card_no"
            name="银行卡号"
            label="银行卡号"
            placeholder="银行卡号"
            :rules="[{ required: true, message: '请填写银行卡号' }]"
          />
          <van-field
            v-model="postForm.deposit_name"
            name="开户行名称"
            label="开户行名称"
            placeholder="开户行名称"
            :rules="[{ required: true, message: '请填写开户行名称' }]"
          />
          <van-field
            v-model="postForm.bank"
            name="银行名称"
            label="银行名称"
            placeholder="银行名称"
            :rules="[{ required: true, message: '请填写银行名称' }]"
          />
          <uploader :imgUrl="postForm.card_no_front_img" @changeImage="changeCardFrontImg"  :title="postForm.card_no_front_title"></uploader>
          <uploader :imgUrl="postForm.card_no_back_img" @changeImage="changeCardBackImg"  :title="postForm.card_no_back_title"></uploader>
        </van-collapse-item>
      </van-collapse>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getManInfo, updateManInfo} from '@/api/user'
import Uploader from './components/uploader'

export default {
  name: 'info',
  components: {
    Uploader
  },
  data () {
    return {
      postForm: {
        name: '',
        id_card: '',
        id_card_img_front: '',
        id_card_img_front_title: '正面',
        id_card_img_back: '',
        id_card_img_back_title: '反面',
        health_code_img: '',
        health_code_img_title: '健康码',
        trajectory_img: '',
        trajectory_img_title: '行动报告',
        nucleic_img: '',
        nucleic_img_title: '核酸检测图片',
        pass_check_img: '',
        pass_check_title: '反面',
        electrician_front_img: '',
        electrician_front_title: '正面',
        electrician_back_img: '',
        electrician_back_title: '反面',
        refrigeration_front_img: '',
        refrigeration_front_title: '正面',
        refrigeration_back_img: '',
        refrigeration_back_title: '反面',
        high_front_img: '',
        high_front_title: '正面',
        high_back_img: '',
        high_back_title: '反面',
        weld_front_img: '',
        weld_front_title: '正面',
        weld_back_img: '',
        weld_back_title: '反面',
        other_front_img: '',
        other_front_title: '正面',
        other_back_img: '',
        other_back_title: '反面',
        bank: '',
        deposit_name: '',
        bank_card_no: '',
        card_no_front_img: '',
        card_no_front_title: '卡号正面',
        card_no_back_img: '',
        card_no_back_title: '卡号反面'
      },
      imageList: [],
      activeNames: ['1'],
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    initUserInfo() {
      if (!localStorage.getItem('id')) {
        this.$router.push('/')
      }
      getManInfo(localStorage.getItem('id')).then((res) => {
        if (res.data.data) {
          this.postForm.name = res.data.data && res.data.data.name
          const details = res.data.data && res.data.data.details
          if (details.length > 0) {
            for (const item in details) {
              const detail = details[item]
              if (typeof detail.content === 'undefined' || detail.content === '') {
                continue;
              }
              if (detail.name === "id_card") {
                this.postForm.id_card = detail.content
              }
              if (detail.name === "id_card_img_front") {
                this.postForm.id_card_img_front = detail.content
              }
              if (detail.name === "id_card_img_back") {
                this.postForm.id_card_img_back = detail.content
              }
              if (detail.name === "trajectory_img") {
                this.postForm.trajectory_img = detail.content
              }
              if (detail.name === "health_code_img") {
                this.postForm.health_code_img = detail.content
              }
              if (detail.name === "nucleic_img") {
                this.postForm.nucleic_img = detail.content
              }
              if (detail.name === "pass_check_img") {
                this.postForm.pass_check_img = detail.content
              }
              if (detail.name === "electrician_front_img") {
                this.postForm.electrician_front_img = detail.content
              }
              if (detail.name === "electrician_back_img") {
                this.postForm.electrician_back_img = detail.content
              }
              if (detail.name === "refrigeration_front_img") {
                this.postForm.refrigeration_front_img = detail.content
              }
              if (detail.name === "refrigeration_back_img") {
                this.postForm.refrigeration_back_img = detail.content
              }
              if (detail.name === "high_front_img") {
                this.postForm.high_front_img = detail.content
              }
              if (detail.name === "high_back_img") {
                this.postForm.high_back_img = detail.content
              }
              if (detail.name === "weld_front_img") {
                this.postForm.weld_front_img = detail.content
              }
              if (detail.name === "weld_back_img") {
                this.postForm.weld_back_img = detail.content
              }
              if (detail.name === "other_front_img") {
                this.postForm.other_front_img = detail.content
              }
              if (detail.name === "other_back_img") {
                this.postForm.other_back_img = detail.content
              }
              if (detail.name === "bank") {
                this.postForm.bank = detail.content
              }
              if (detail.name === "deposit_name") {
                this.postForm.deposit_name = detail.content
              }
              if (detail.name === "bank_card_no") {
                this.postForm.bank_card_no = detail.content
              }
              if (detail.name === "card_no_front_img") {
                this.postForm.card_no_front_img = detail.content
              }
              if (detail.name === "card_no_back_img") {
                this.postForm.card_no_back_img = detail.content
              }
            }
          }
        }
      })
    },
    changeOtherFrontImg(obj) {
      this.other_front_img = obj
    },
    changeOtherBackImg(obj) {
      this.other_back_img = obj
    },
    changeWeldFrontImg(obj) {
      this.weld_front_img = obj
    },
    changeWeldBackImg(obj) {
      this.weld_back_img = obj
    },
    changeHighFrontImg(obj) {
      this.postForm.high_front_img = obj
    },
    changeHighBackImg(obj) {
      this.postForm.high_back_img = obj
    },
    changeRefrigerationFrontImg(obj) {
      this.postForm.refrigeration_front_img = obj
    },
    changeRefrigerationBackImg(obj) {
      this.postForm.refrigeration_back_img = obj
    },
    changeEleFrontImg(obj) {
      this.postForm.electrician_front_img = obj
    },
    changeEleBackImg(obj) {
      this.postForm.electrician_back_img = obj
    },
    changeNucleicImg(obj) {
      this.postForm.nucleic_img = obj
    },
    changeCardBackImg(obj) {
      this.postForm.card_no_back_img = obj
    },
    changeCardFrontImg(obj) {
      this.postForm.card_no_front_img = obj
    },
    changeTrajectoryImg(obj) {
      this.postForm.trajectory_img = obj
    },
    changePassCheckImg(obj) {
      this.postForm.pass_check_img = obj
    },
    changeIdCardFront(obj) {
      this.postForm.id_card_img_front = obj
    },
    changeIdCardBack(obj) {
      this.postForm.id_card_img_back = obj
    },
    changeHealthCodeImg(obj) {
      this.postForm.health_code_img = obj
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.push('/my')
    },
    beforeRead() {

    },
    deleteFile() {

    },
    onRead() {

    },
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后重新发送`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          this.reset()
        }
      }, 1000)
    },
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '点击发送验证码'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    },
    forwardLogin() {
      this.$router.push({path: '/'})
    },
    onSubmit () {
      if (!localStorage.getItem('id')) {
        this.$router.push('/')
        return false
      }
      console.log("hello world......")
      if (this.postForm.name === '' || typeof this.postForm.name === 'undefined') {
        Toast('姓名不能为空');
        return false;
      }
      if (this.postForm.id_card === '' || typeof this.postForm.id_card === 'undefined') {
        Toast('身份证号码不能为空');
        return false;
      }
      const data = {}
      for (const item in this.postForm) {
        if (this.postForm[item].indexOf("?") > -1) {
          data[item] = this.postForm[item].substring(0, this.postForm[item].indexOf("?"))
        } else {
          data[item] = this.postForm[item]
        }
      }

      updateManInfo(localStorage.getItem('id'), data).then((res) => {
        if (res.data.code === 0) {
          Toast("提交成功");
          this.$router.push('/my')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/info.vue